import { PhoneField } from "components/phone-field";
import { TextField } from "components/text-field";
import type { PsychologistProfile } from "core/types";
import { useTranslation } from "react-i18next";
import { type PhoneFieldChangeValue } from "components/phone-field";
import { ChangeEvent } from "react";

type Props = {
  psychologist: Pick<PsychologistProfile, "phone" | "hsa">;
  onChange: (
    x: string,
  ) => (arg: PhoneFieldChangeValue | ChangeEvent<HTMLInputElement>) => void;

  psychologistValidation: string[];
};

const EditablePhoneAndEditableAdeli = ({
  psychologist,
  onChange,
  psychologistValidation,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div>
      <PhoneField
        value={psychologist.phone ?? ""}
        sensitive={true}
        label={`${t("PHONE_NUMBER")}*`}
        onChange={onChange("phone")}
        error={psychologistValidation.indexOf("phone") !== -1}
        errorMessage={t("PHONE_NUMBER_NOT_VALID")}
      />
      <TextField
        error={psychologistValidation.indexOf("hsa") !== -1}
        label={`${t("FR_ADELI")}*`}
        value={psychologist.hsa ?? ""}
        sensitiveField={true}
        onChange={onChange("hsa")}
        errorMessage={t("REQUIRE_ADELI")}
      />
    </div>
  );
};

export default EditablePhoneAndEditableAdeli;
